import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TechStrip from './components/TechStrip';
import Services from './components/Services';
import Projects from './components/Projects';
import AICapabilities from './components/AICapabilities';
import Process from './components/Process';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <>
      <a href="#main" className="skip-link">
        Skip to main content
      </a>
      <Navbar />
      <main id="main">
        <Hero />
        <TechStrip />
        <Services />
        <Projects />
        <AICapabilities />
        <Process />
        <About />
        <Contact />
      </main>
      <Footer />
    </>
  );
}

export default App;
